<template>
  <div class="main-footer">
    <div container>
      <div grid="row wrap">
        <div class="flex-wrap">
          <img
            class="lockup desktop"
            :src="desktopImageUrl"
            alt="independant providers lenscrafter pearle vison optical sears optical"
          >
          <img
            class="lockup mobile"
            :src="mobileImageUrl"
            alt="independant providers lenscrafter pearle vison optical sears optical"
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    props: ['mobileImageUrl', 'desktopImageUrl']
  }
</script>
